export default "__VITE_ASSET__27ea7656__"